import { motion } from 'framer-motion';
import React from 'react';
import MagentaLine from '../elements/MagentaLine';
import Bg from '../../images/ui/dark-blue-bg.jpg';
import VideoBg from '../../video/modal-blue-bg.mp4';
import MoreSoundAmpBg from '../../images/brainhearing-technology/more-sound-amplifier-bg.jpg';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      delayChildren: 3.6,
      staggerChildren: 0.4,
    },
  },
};

const item = {
  hidden: { opacity: 0, x: -100 },
  show: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};
export default function MoreSoundAmplifier() {
  return (
    <div id="more-sound-amplifier" className="bh-tech-subpage">
      <img src={Bg} alt="" className="modal-full-bg" />
      <motion.video
        src={VideoBg}
        className="modal-full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <img src={MoreSoundAmpBg} alt="" id="bg" />
      <header>
        <MagentaLine height="125px" left="19px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '28px',
              left: '18px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            MoreSound Amplifier™
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '23px',
              top: '66px',
              left: '18px',
              letterSpacing: '0.5px',
              lineHeight: '32px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            <strong>Dynamic, balanced and seamless</strong>
            <br />
            amplification system
          </motion.div>
        </div>
      </header>
      <motion.div
        id="heading"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 2.6 }}
      >
        MoreSound Amplifier includes:
      </motion.div>
      <motion.ul variants={container} initial="hidden" animate="show">
        <motion.li variants={item}>
          Six-times increase in resolution for more precise amplification
        </motion.li>
        <motion.li variants={item}>
          Adaptive speed pilot to make sound scene audible while maintaining
          contrast and balance between sounds
        </motion.li>
        <motion.li variants={item}>
          Constant prioritizing of 4-channel or 24-channel paths based on
          incoming signal
        </motion.li>
      </motion.ul>
    </div>
  );
}
